import React from 'react';
import { motion } from 'framer-motion';
export function NewIn() {
  const images = ['https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png', 'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png', 'https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png', 'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png'];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-516">
      <div className="max-w-[1800px] mx-auto" data-id="element-517">
        <header className="mb-20 text-center" data-id="element-518">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-519">
            Latest Arrivals
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-520">
            New In
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-521">
            The newest expressions of Djili heritage. Fresh silhouettes and
            vibrant textiles just arrived.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-522">
          {images.map((img, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="group cursor-pointer" data-id="element-523">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-524">
                <img src={img} alt="New Arrival" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-525" />
              </div>
              <h3 className="text-[11px] font-display font-bold tracking-widest uppercase mb-1" data-id="element-526">
                New Arrival {i + 1}
              </h3>
              <p className="text-xs font-light text-black/50" data-id="element-527">$280.00</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}